<template>
  <div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="商户名称">
        <el-input v-model="formInline.name" placeholder="商户名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增商户</el-button>
      </el-form-item>
    </el-form>
    <el-table border :data="tableData" style="width: 500px">
      <el-table-column prop="name" label="商户名称"> </el-table-column>
      <el-table-column prop="list" label="设备列表">
        <template slot-scope="scope">
            <button @click="gotoDeviceList(scope.row.id,scope.row.name)">查看</button>

        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
  </div>
</template>

<script>
   import Pagination from '@/components/Pagination';
export default {
    
  data() {
    return {
      formInline: {
        name: "",
      },
      pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
      tableData: [],
    };
  },
  methods: {
    onSubmit(e) {
      console.log("submit!", this.formInline);
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        name: this.formInline.name,
      };
      this.$http.post("/merchant/merchant/list", params).then((results) => {
        this.tableData = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });

    },
    gotoDeviceList(id,name){
        const isGdLl = name === '广东冷链协会' ? '?isGdLl=true' : ''
        const isYLZ = name === '运荔枝' ? '?isYLZ=true' : ''
        const isCP = name === '参盘' ? '?isCP=true' : ''
        this.$router.push('/api/index/device/' + id + (isGdLl || isYLZ || isCP));
    },
    add() {
        this.$router.push('/api/index/addM');
    },
  },
  components: { Pagination }
};
</script>
